// extracted by mini-css-extract-plugin
export default {"productDescription":"X_-z","featuredDescription":"Y_-z","description":"Z_-z","more":"__-z","descriptionSku":"aaa-z"};